<template>
  <div class="cookies-content" :class="{ animation: isAccepted }">
    <div class="cookies-container">
      <div class="left-content">
        <div class="text-item text-title font-18 lh-24">
          {{ $fn.tr("Cookies Politics") }}
        </div>
        <div class="text-item font-18 lh-27 text-overflow--line4 tbc-regular">
          {{ $fn.tr("Cookies text") }}
        </div>
      </div>
      <div class="cookie-options">
        <p class="tbc-bold font-18 lh-24 mr15" @click="acceptCookies">
          {{ $fn.tr("Accept") }}
        </p>
        <p class="tbc-bold font-18 lh-24" @click="showModal = true">
          {{ $fn.tr("Costumize") }}
        </p>
      </div>
    </div>
    <Modal
      :showModal="showModal"
      @closeModal="showModal = false"
      @acceptCookie="acceptCookies"
    />
  </div>
</template>

<script>
import Modal from "./CookiesModal";
export default {
  components: {
    Modal
  },
  data() {
    return {
      showModal: false,
      isAccepted: false
    };
  },
  computed: {
    localStorageStatus() {
      return typeof localStorage.getItem("accept_cookies") === "string" &&
        localStorage.getItem("accept_cookies") !== "undefined"
        ? JSON.parse(localStorage.getItem("accept_cookies"))
        : false;
    }
  },
  watch: {
    localStorageStatus: {
      immediate: true,
      handler(val) {
        this.isAccepted = val;
      }
    }
  },

  methods: {
    acceptCookies() {
      localStorage.setItem("accept_cookies", true);
      this.isAccepted = true;
    }
  }
};
</script>

<style scoped>
.mr15 {
  margin-right: 39px;
}
.cookies-container {
  padding: 0 70px;
}
.cookies-content {
  padding: 30px 0 30px;
  background: #364756;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 144px;
  transition: 0.7s;
  z-index: 9999999999;
}
.left-content {
  max-width: 75%;
}
.cookies-content .cookies-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.animation {
  opacity: 0;
  visibility: hidden;
  transition: 0.7s;
}
.text-item.text-title {
  color: var(--tbc-blue);
  margin-bottom: 15px;
}
.text-item {
  color: white;
  padding-right: 20px;
  line-height: 30px;
  /* margin-bottom: 25px; */
}
.cookie-options {
  display: flex;
  align-items: center;
}
.cookie-options p {
  color: white;
  transition: 0.4s;
  cursor: pointer;
}
.cookie-options p:first-child {
  color: var(--tbc-blue);
}
.cookie-options p:hover {
  color: var(--tbc-blue);
  transition: 0.4s;
}
@media (max-width: 1023px) {
  .cookies-container {
    padding: 0 20px;
  }
  .cookies-content {
    height: auto;
  }
  .cookies-content .cookies-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .text-item {
    margin-bottom: 15px;
  }
  .text-item.text-overflow--line2 {
    -webkit-line-clamp: 3;
  }
}
@media (max-width: 767px) {
  .left-content {
    max-width: unset;
  }
  .text-item {
    padding-right: 0;
  }
  .cookie-options {
    flex-wrap: wrap;
  }
  .text-overflow--line4 {
    max-height: 150px;
    overflow: auto;
    display: block;
  }
}
</style>
